import {component_tool, framework_tool, utils_tool} from "@/tool";

import React from 'react';
import UserRoleSelect from './roleSelect/userRoleSelect';
import UserGroupSelect from './groupSelect/userGroupSelect';
import UserUpdate from './userUpdate';

let {
  WizReduxTemplate,
  WizTableList,
  WizAlert,
  WizRow,
  WizCol,
  WizIcon
} = framework_tool;
let {$$,checkStrLength} = utils_tool;
let {WizModal} = component_tool;
//配置项
let componentName = 'userManagement';
let ref;
let ref_;
let ref_group;

// 自定义UI组件 账号字段下的提示部分
const Alert = () => (
  <WizRow>
    <WizCol md={24} lg={12}>
      <WizAlert message="账号初始密码为:sgm123456" type="info" showIcon/>
    </WizCol>
  </WizRow>
);
const message = (<React.Fragment>账号初始密码为:sgm123456</React.Fragment>);
const columns =(data)=>{return  [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "personId",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "password",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "salt",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "wechatUserId",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "createTime",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "createBy",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "searchUserName",
    searchItem: {}
  },
  {
    title: "账号",
    name: "userName",
    tableItem: {
      width: 120,
    },
    formItem: {
      disabled:data,
      maxlength: 20,
      rules: [{
        required: true,
        message: '请输入账号',
      },{
        pattern: /^[A-Za-z0-9-_]+$/,
        message: '账号仅支持输入数字、字母、-、_'
      }],
      placeholder: "账号不能超过20个字符。"
    }
  },
  {
    title: "姓名",
    name: "searchFullName",
    searchItem: {}
  },
  {
    title: "姓名",
    name: "fullName",
    tableItem: {
      width: 100,
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入姓名',
      }, {
        max: 32,
        message: '姓名长度不能超过32个字符'
      }],
      placeholder: "姓名不能超过32个字。"
    }
  },
  // {
  //   title: "手机号",
  //   name: "searchMobile",
  //   searchItem: {}
  // },
  {
    title: "手机号",
    name: "mobile",
    tableItem: {
      width: 120,
    },
    formItem: {
      rules: [{
        pattern: /^(1)\d{10}$/,
        message: "手机号不合法"
      }, {
        max: 11,
        message: '手机号长度不能超过11个字符'
      }],
      placeholder: '请输入手机号',
    }
  },
  {
    title: "邮箱",
    name: "searchEmail",
    searchItem: {}
  },
  {
    title: "邮箱",
    name: "email",
    tableItem: {
      width: 200,
    },
    formItem: {
      rules: [
        {
          pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
          message: "邮箱不合法"
        }, {
          max: 64,
          message: '邮箱长度不能超过64个字符'
        }
      ]
    }
  },
  {
    title: "状态",
    name: "disabled",
    dataIndex: "disabled",
    tableItem: {
      width: 100,
    },
    dict: [
      {code: 0, codeName: "有效"},
      {code: 1, codeName: "无效"}
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "radio",
      initialValue: 0
    },
    extra: '账号初始密码为:sgm123456'
  },
  {
    title: "创建时间",
    name: "createTime",
    tableItem: {
    }
  }
]};

const templateConfig =(data)=>{return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns : columns(undefined),
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['add', 'delete', 'resetPassword'],
        buttons: [
          {
            key: "delete",
            custom: true,
            needSelect: true,
            params: {icon: "delete", children: "删除", type: "danger"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                // const content = `删除后数据不可恢复，您确定要删除这${
                //   $$.isArray(rows) ? rows.length : ""
                // }条账户吗？`;
                const content = '删除后数据不可恢复，您确定要删除选中的用户吗？'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']){
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "resetPassword",
            custom: true,
            needSelect: true,
            params: {icon: "redo", children: "重置密码", type: "info"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "resetPassword",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                // const content = `您确定要重置这${
                //   $$.isArray(rows) ? rows.length : ""
                // }条账户密码？重置后密码为：sgm123456`;
                const content = '您确定要重置选中的用户密码吗？重置后密码为sgm123456'
                let ids = [];
                rows.forEach(e => {
                  if (e['rowKey']){
                    ids.push(e['rowKey']);
                  }
                });
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ids
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['update', 'enableOrDisable', 'roleManagement','userGroupManagement'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: {  children: '编辑' },
          customOnClick: {
            key: "modal",
            params: {
              modalKey:new Date().getTime(),
              modalParams: {
                title: "编辑",
                diy: (e) => {
                  e.record = Object.assign({},e.record)
                  const formProps = {
                    ref: 'form',
                    columns:columns(true),
                    record:e.record,
                    preview: false,
                    footer: false,
                    formItemLayout: {
                      labelCol: { span: 4 },
                      wrapperCol: { span: 17 }
                    },
                  };
                  return(
                    <UserUpdate {...formProps}
                    key={new Date().getTime()}
                    {...e}
                    ref={r => {
                       ref_ = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                onOk: () => {
                  ref_._userUpdate()
                },
                onCancel: () => {
                  ref_._userReset()
                },
                width: 700
              }
            },
            formatParams: (rows, record, filter) => {
              return { ...record };
            }
          }
        },



        {
          key: "enableOrDisable",
          custom: true,
          params: {children: "激活"},
          textFormat: {
            recordKey: 'disabled',
            dirt: {0: '禁用', 1: '激活'}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateUserDisabled",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['disabled'] === 0 ? "禁用" : "激活"
              }该账号吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    disabled: record['disabled'] === 0 ? 1 : 0,
                    personId: record['personId']
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "roleManagement",
          custom: true,
          params: {children: "角色管理"},
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "用户角色管理",
                diy: (e) => {
                  return (
                    <UserRoleSelect
                      key={e.record.id}
                      {...e}
                      ref={r => {
                        ref = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                onOk: () => {
                  ref._doRoleUserAdd()
                },
                onCancel: () => {
                  ref._doInitParams()
                },
                width: 850
              }
            }
          }
        },
        {
          key: "userGroupManagement",
          custom: true,
          params: {children: "用户组管理"},
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "用户组管理",
                diy: (e) => {
                  return (
                    <UserGroupSelect
                      key={e.record.id}
                      {...e}
                      ref={r => {
                        ref_group = r && r.getWrappedInstance();
                      }}
                    />
                  )
                },
                onOk: () => {
                  ref_group._doGroupUserAdd()
                },
                onCancel: () => {
                  ref_group._doInitParams()
                },
                width: 850
              }
            }
          }
        }
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true
      }
    }
  }
}
};


const apis = {
  list: {
    path: `${componentName}/userList`,
    payload: {
      key: `${componentName}@userList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  add: {
    path: `${componentName}/addUser`,
    payload: {
      key: `${componentName}@addUser`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/updateUser`,
    payload: {
      key: `${componentName}@updateUser`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/deleteUser`,
    payload: {
      key: `${componentName}@deleteUser`,
      apiParams: {}
    }
  },
  resetPassword: {
    path: `${componentName}/userResetPassword`,
    payload: {
      key: `${componentName}@userResetPassword`,
      apiParams: {}
    }
  },
  updateUserDisabled: {
    path: `${componentName}/updateUserDisabled`,
    payload: {
      key: `${componentName}@updateUserDisabled`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
